import callAPI from "../../../helpers/callAPI"

export default async function getCreativePreview (type, creativeId, campaignId, advertiserId){
    const response = await callAPI(`campaign/${campaignId}/creatives/${advertiserId}/preview/?creativeType=${type}&creativeId=${creativeId}`, 'GET')

    if (response.success) {
        return response.content
    }
}